import { useItem } from './Item.h'
import { usePermission } from '@shared/hooks/permissions'

import Box from '@mui/material/Box'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import TimerIcon from '@mui/icons-material/Timer'
import workTypes from '@shared/utils/workTypes'
import PushPinIcon from '@mui/icons-material/PushPin'
import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

// it's compatible only with InfiniteList
export default function EstimationItem({
    item,
    options,
    infiniteScroll=false
}) {
    const {
        handleClick,
        handleEdit,
        handleDelete,
        handleExport,
        handlePin,

        anchor,
        setAnchor
    } = useItem(item)
    const { hasPermission } = usePermission()

    return (
        <>
            <ListItem
                disablePadding
                sx={{
                    width: '100%',
                    ...(infiniteScroll
                        ? {
                            position: 'absolute',
                            transform: `translateY(${options.start}px)`
                        } : {}
                    )
                }}
                secondaryAction={
                    <IconButton onClick={e => setAnchor(e.currentTarget)}>
                        <MoreVertIcon />
                    </IconButton>
                }
            >
                <ListItemButton onClick={handleClick}>
                    {item.is_pinned &&
                        <ListItemIcon>
                            <PushPinIcon fontSize='small'/>
                        </ListItemIcon>
                    }
                    <ListItemText
                        primary={
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: .5
                            }}>
                                {item.is_draft
                                    ? <TimerIcon
                                            color='action'
                                            sx={{ fontSize: '1rem' }}
                                        />
                                    : <CheckCircleIcon
                                            color='success'
                                            sx={{ fontSize: '1rem' }}
                                        />
                                }
                                <span>{item.number}</span>
                            </Box>
                        }
                        secondary={`${workTypes[item.work_type]} ━ ${item.last_update}`}
                    />
                </ListItemButton>
            </ListItem>
            <Menu
                open={!!anchor}
                onClose={() => setAnchor(null)}
                anchorEl={anchor}
            >
                {hasPermission('change_estimation') && <MenuItem onClick={handleEdit}>تعديل</MenuItem>}
                {hasPermission('delete_estimation') && <MenuItem onClick={handleDelete}>حذف</MenuItem>}
                <MenuItem onClick={handleExport}>تصدير</MenuItem>
                <MenuItem onClick={handlePin}>تثبيت</MenuItem>
            </Menu>
        </>
    )
}